import config from 'config';
import * as Sentry from '@sentry/vue';

const ENV = config.sentry.env;

export default {
  setup: (app) => {
    if (ENV !== 'DEVELOPMENT') {
      Sentry.init({
        app,
        dsn: config.sentry.dsn,
        environment: config.sentry.env,
        // Sentry 11 collects user info, cookies and request bodies by default; keep the v10 behaviour
        dataCollection: { userInfo: false, cookies: false, httpBodies: [] }
      });
    }
  }
};
